<template>
  <div>
    <van-row class="info">
      <van-col :span="24" class="header">
        <img class="photo" :src="userinfo?.avatar" alt="" />
        <div>
          <span>{{ userinfo?.nickname }}</span>
          <img class="editicon" @click="toUserinfo()" src="@/assets/images/editinfo.png" alt="" />
        </div>
      </van-col>
      <van-col :span="24" class="options">
        <van-cell is-link @click="toMyactive()">
          <img src="@/assets/images/myactive.png" alt="" />
          我的活动
        </van-cell>
      </van-col>
      <van-col :span="24" class="options">
        <van-cell is-link @click="toProtocol()">
          <img src="@/assets/images/agreement.png" alt="" />
          用户协议
        </van-cell>
      </van-col>
      <van-col :span="24" class="options">
        <van-cell is-link @click="toPolicy()">
          <img src="@/assets/images/policy.png" alt="" />
          隐私政策
        </van-cell>
      </van-col>
      <van-col :span="24" class="options">
        <van-cell is-link @click="logout()">
          <img src="@/assets/images/goout.png" alt="" />
          退出账号
        </van-cell>
      </van-col>
    </van-row>

    <van-row :gutter="15" class="btns">
      <van-col :span="12">
        <van-button :class="active == 1 ? 'active' : ''" round @click="select(1)">活动列表</van-button>
      </van-col>
      <van-col :span="12">
        <van-button round :class="active == 2 ? 'active' : ''" @click="select(2)">个人中心</van-button>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import { getuserinfo } from "@/api/home";
import { removeToken } from '@/utils/token-util';
import { Dialog } from 'vant';
export default {
  data() {
    return {
      value: null,
      active: 2,
      userinfo: null
    };
  },
  methods: {
    select(num) {
      // console.log(num);
      this.active = num;
      if (num == 1) {
        this.$router.push({
          path: "/",
        });
      } else {
        // this.$router.push({
        //   path: "/user",
        // });
      }
    },
    toMyactive() {
      this.$router.push({
        path: "/myactive",
      });
    },
    toUserinfo() {
      this.$router.push({
        path: "/userinfo",
      });
    },
    getinfo() {
      getuserinfo().then((res) => {
        // console.log(res);
        this.userinfo = res;
      }).catch((err) => {
        console.log(err);
      });
    },
    toProtocol() {
      this.$router.push({
        path: "/protocol"
      })
    },
    toPolicy() {
      this.$router.push({
        path: "/policy"
      })
    },
    logout() {
      Dialog.confirm({
        title: '提示',
        message: '请确认是否退出当前账号',
      })
        .then(() => {
          removeToken();
          this.$router.push({
            path: "/login"
          })
        })
        .catch(() => {
          
        });
    }
  },
  created() {
    this.getinfo();
  },
};
</script>
<style lang="scss" scoped>
.info {
  padding: 30px 18px;

  .van-col {
    border-bottom: 1px solid #f2f0f0;
  }

  .header {
    font-size: 16px;

    .photo {
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }

    div {
      display: flex;
      align-content: center;
      justify-content: center;
      margin: 15px 0 60px;

      img {
        margin-left: 6px;
      }
    }

    .editicon {
      width: 18px;
      height: 18px;
    }
  }

  .options {
    .van-cell {
      padding: 15px 15px 20px;
    }

    .van-cell__value {
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
        width: 22px;
        height: 19px;
      }
    }
  }

  .van-button {
    width: 100%;
    background-color: #2553e2;
    color: #fff;
  }
}

.btns {
  width: 100%;
  padding: 0px 18px 20px;
  position: fixed;
  bottom: 0px;
  left: 0;
  box-sizing: border-box;

  .van-button {
    width: 100%;
    background-color: #fff;
    border-color: #2553e2;
    color: #2553e2;
  }

  .active {
    background-color: #2553e2;
    color: #fff;
  }
}
</style>